import { EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ShipUser } from 'src/app/ShipUser';
import { ShipUserService, UserRole } from 'src/app/services/ship-user.service';
import { ShipService } from 'src/app/services/ship.service';
import { Ship } from 'src/app/Ship';
import { locationRequiredForRole } from 'src/app/validators/forms-validator';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-ship-user-form',
  templateUrl: './ship-user-form.component.html'
})
export class ShipUserFormComponent implements OnInit {
  readonly NC_SHIP_SUPPORT_ROLE = 'NC_SHIP_SUPPORT';
  readonly NC_SHIP_SUPPORT_LOCATION = 'SUPPRT';
  @Input() userCardNumber: number = null;
  @Output() onUserEntryCancelled = new EventEmitter<boolean>();
  @Output() onUserEntrySuccess = new EventEmitter<boolean>();
  userRoleValues$: Observable<UserRole[]>;
  locationValues$: Observable<Ship[]>;
  userForm: UntypedFormGroup = null;
  shipUser: ShipUser;
  loading = true;

  constructor(
    private shipUserService: ShipUserService,
    private shipService: ShipService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.userRoleValues$ = this.shipUserService.getShipUserRoles();

    this.locationValues$ = this.shipService.getShipsCommon().pipe(
      tap((val) => {
        this.loading = false;
      }),
      map((val) => {
        return val.sort((a, b) =>
          a.shipLocation > b.shipLocation
            ? 1
            : a.shipLocation < b.shipLocation
            ? -1
            : 0
        );
      })
    );

    this.userForm = new UntypedFormGroup(
      {
        role: new UntypedFormControl('', [Validators.required]),
        location: new UntypedFormControl(''),
        enabled: new UntypedFormControl(true)
      },
      {
        validators: [locationRequiredForRole()],
        updateOn: 'change'
      }
    );

    this.shipUserService
      .getUserByCardPan(+this.userCardNumber)
      .pipe(
        tap((user) => {
          this.shipUser = user || new ShipUser();
          this.userForm.get('role').setValue(this.shipUser.role);
          this.userForm.get('location').setValue(this.shipUser.location);
          this.userForm.get('enabled').setValue(this.shipUser.enabled);
          if (this.shipUser.role == this.NC_SHIP_SUPPORT_ROLE) {
            this.userForm.controls['location'].disable();
          }
        })
      )
      .subscribe();
  }

  submitUserForm() {
    const submitUser = <ShipUser>this.userForm.value;
    submitUser.cardPan = this.userCardNumber;
    if (this.userForm.get('role').value == this.NC_SHIP_SUPPORT_ROLE) {
      submitUser.location = this.NC_SHIP_SUPPORT_LOCATION;
    }
    this.shipUserService.createOrUpdateShipUser(submitUser).subscribe(
      () => {
        this.messageService.success(
          'Ship user information processed successfuly!'
        );
        this.onUserEntrySuccess.emit(true);
      },
      () => {
        this.messageService.error(
          'There was an errory while processing ship user information'
        );
      }
    );
  }

  cancelUserForm(evt: Event) {
    evt.preventDefault();
    this.userForm = null;
    this.onUserEntryCancelled.emit(true);
  }

  updateLocationStatus(evt: Event) {
    const roleSelect = evt.target as HTMLSelectElement;
    const selectedRole = roleSelect.options[roleSelect.selectedIndex].value;
    const locationControl = this.userForm.controls['location'];
    if (selectedRole == this.NC_SHIP_SUPPORT_ROLE) {
      locationControl.setValue(this.NC_SHIP_SUPPORT_LOCATION);
      locationControl.disable();
    } else {
      if (this.shipUser.location == this.NC_SHIP_SUPPORT_LOCATION) {
        locationControl.setValue('');
      } else {
        locationControl.setValue(this.shipUser.location);
      }
      locationControl.enable();
    }
  }
}
